// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"b7f9c511","560":"2dd28ed4"}[chunkId] + ".chunk.css";
};